import DOMPurify from 'dompurify';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ReactMarkdown from 'react-markdown';

interface MarkdownContentProps {
  content: string;
}

/**
 * Renders the provided content as markdown.
 */
export default function MarkdownContent({content}: MarkdownContentProps): JSX.Element {
  const renderedMarkdown = ReactDOMServer.renderToStaticMarkup(<ReactMarkdown>{content}</ReactMarkdown>);
  const sanitizedMarkdown = DOMPurify.sanitize(renderedMarkdown);
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(sanitizedMarkdown)}} />;
}
